import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { produce } from 'immer';
import createStore from '../../../../plugins/utils/createStore';
import { TagsIcon, TagIcon } from '../../../Icons';
import ColumnTypes from '../../types/ColumnTypes';
import generateKey from '../../utils/generateKey';
import { DATABASE_ADD_TAG } from '../../../../types/AnalyticsTypes';
import Field from './components/Field';
import ColumnHeader from './components/ColumnHeader';
import textSort from '../utils/textSort';
var SELECT_COLUMN_TYPES = [ColumnTypes.MULTI_SELECT, ColumnTypes.SELECT];
export default function SelectPlugin() {
  var store = createStore();
  return [{
    queries: {
      getColumnSelectOptions: function getColumnSelectOptions(database, columnKey) {
        return database.getColumn(columnKey).data.options || {};
      },
      getColumnSelectOption: function getColumnSelectOption(database, columnKey, optionKey) {
        return database.getColumnSelectOptions(columnKey)[optionKey];
      },
      getFieldSelectOptionsKeys: function getFieldSelectOptionsKeys(database, recordKey, columnKey) {
        var field = database.getField(recordKey, columnKey);
        return !field || !field.data.options ? [] : Object.keys(field.data.options);
      },
      mapFieldSelectOptions: function mapFieldSelectOptions(database, recordKey, columnKey) {
        return database.getFieldSelectOptionsKeys(recordKey, columnKey).map(function (key) {
          return database.getColumnSelectOption(columnKey, key);
        }).filter(function (x) {
          return x;
        });
      }
    },
    commands: {
      addSelectOptionToField: function addSelectOptionToField(database, recordKey, columnKey, optionKey) {
        var columnType = database.getColumn(columnKey).type;
        var fieldData = database.getFieldData(recordKey, columnKey);
        var previousOptions = fieldData.options && columnType === ColumnTypes.MULTI_SELECT ? fieldData.options : {};
        var updatedData = {
          options: _objectSpread({}, previousOptions, _defineProperty({}, optionKey, true))
        };
        return database.mergeFieldData(recordKey, columnKey, updatedData);
      },
      removeSelectOptionFromField: function removeSelectOptionFromField(database, recordKey, columnKey, option) {
        var fieldData = database.getFieldData(recordKey, columnKey);
        var updatedData = produce(fieldData, function (data) {
          if (!data.options || !data.options[option.key]) return;
          delete data.options[option.key];
        });
        return database.mergeFieldData(recordKey, columnKey, updatedData);
      },
      emptySelectField: function emptySelectField(database, recordKey, columnKey) {
        var fieldData = database.getFieldData(recordKey, columnKey);
        var updatedData = produce(fieldData, function (data) {
          data.options = {};
        });
        return database.mergeFieldData(recordKey, columnKey, updatedData);
      },
      addSelectOption: function addSelectOption(database, columnKey) {
        var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return database.updateSelectOption(columnKey, _objectSpread({
          key: generateKey(),
          label: ''
        }, option)).command('track', DATABASE_ADD_TAG);
      },
      updateSelectOption: function updateSelectOption(database, columnKey, option) {
        var updatedData = produce(database.getColumn(columnKey).data, function (data) {
          if (!data.options) {
            data.options = {};
          }

          data.options[option.key] = option;
        });
        return database.setColumn(columnKey, {
          data: updatedData
        });
      },
      removeSelectOption: function removeSelectOption(database, columnKey, option) {
        // Remove option from all fields' data
        var records = database.getRecords();
        Object.keys(records).map(function (recordKey) {
          return database.removeSelectOptionFromField(recordKey, columnKey, option);
        }); // Remove option from column's data

        var updatedData = produce(database.getColumn(columnKey).data, function (data) {
          delete data.options[option.key];
        });
        return database.setColumn(columnKey, {
          data: updatedData
        });
      }
    },
    onStartTyping: function onStartTyping(event, database, next) {
      var _database$getActive = database.getActive(),
          column = _database$getActive.column,
          record = _database$getActive.record;

      if (!SELECT_COLUMN_TYPES.includes(column.type)) {
        return next();
      }

      var fieldKey = database.getFieldKey(record.key, column.key);
      store.updateItem(fieldKey, {
        value: event.key.length === 1 ? event.key : ''
      });
      next();
    },
    renderColumnType: function renderColumnType(columnType, database, next) {
      if (columnType === ColumnTypes.MULTI_SELECT) {
        return 'Tags';
      }

      if (columnType === ColumnTypes.SELECT) {
        return 'Select';
      }

      return next();
    },
    renderColumnIcon: function renderColumnIcon(columnType, database, next) {
      if (columnType === ColumnTypes.MULTI_SELECT) {
        return React.createElement(TagsIcon, null);
      }

      if (columnType === ColumnTypes.SELECT) {
        return React.createElement(TagIcon, null);
      }

      return next();
    },
    getWidth: function getWidth(columnType, database, next) {
      if (SELECT_COLUMN_TYPES.includes(columnType)) {
        return 160;
      }

      return next();
    },
    canSort: function canSort(columnType, database, next) {
      if (!SELECT_COLUMN_TYPES.includes(columnType)) {
        return next();
      }

      return true;
    },
    getSortOptions: function getSortOptions(columnType, database, next) {
      if (!SELECT_COLUMN_TYPES.includes(columnType)) {
        return next();
      }

      return textSort.options;
    },
    getSortStrategies: function getSortStrategies(columnType, database, next) {
      if (!SELECT_COLUMN_TYPES.includes(columnType)) {
        return next();
      }

      var getfirstTag = function getfirstTag(_ref) {
        var record = _ref.record,
            column = _ref.column;
        var option = database.mapFieldSelectOptions(record.key, column.key)[0];
        return option ? option.label.toLowerCase() : '';
      };

      return textSort.strategies(columnType, database, getfirstTag);
    },
    renderField: function renderField(props, database, next) {
      if (SELECT_COLUMN_TYPES.includes(props.column.type)) {
        return React.createElement(Field, Object.assign({
          database: database,
          store: store
        }, props));
      }

      return next();
    },
    renderColumnOptions: function renderColumnOptions(props, database, next) {
      if (SELECT_COLUMN_TYPES.includes(props.column.type)) {
        return React.createElement(ColumnHeader, Object.assign({
          database: database
        }, props));
      }

      return next();
    },
    convertField: function convertField(source, destination, database, next) {
      var column = destination.column;
      if (!SELECT_COLUMN_TYPES.includes(column.type)) return next();
      var fieldAsText = typeof source === 'string' ? source : database.run('serializeField', source);
      var labels = fieldAsText.split(/,\s?/);
      return {
        options: labels.reduce(function (acc, label) {
          var _ref2 = Object.entries(column.data.options || []).find(function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 2),
                key = _ref5[0],
                option = _ref5[1];

            return option.label === label;
          }) || [],
              _ref3 = _slicedToArray(_ref2, 1),
              existingOptionKey = _ref3[0];

          if (existingOptionKey) {
            acc[existingOptionKey] = true;
          } else {
            var key = generateKey();
            database.updateSelectOption(column.key, {
              key: key,
              label: label
            });
            acc[key] = true;
          }

          return acc;
        }, {})
      };
    },
    serializeField: function serializeField(_ref6, database, next) {
      var field = _ref6.field,
          record = _ref6.record,
          column = _ref6.column;
      if (!SELECT_COLUMN_TYPES.includes(column.type)) return next();
      return Object.keys(field.data.options).map(function (option) {
        return column.data.options[option].label;
      }).join(', ');
    }
  }];
}